import * as api from '../../../clients/incidents';

import {Action} from '@ngrx/store';

export const GET_MEINE_ERSTELLTEN_INCIDENTS = '[IncidentsModul] GetMeineErstelltenIncidents laden';
export const GET_MEINE_ERSTELLTEN_INCIDENTS_AUSFUEHREN = '[IncidentsModul] GetMeineErstelltenIncidents ausführen';
export const GET_MEINE_ERSTELLTEN_INCIDENTS_ERFOLGREICH = '[IncidentsModul] GetMeineErstelltenIncidents laden erfolgreich';
export const GET_MEINE_ERSTELLTEN_INCIDENTS_FEHLER = '[IncidentsModul] GetMeineErstelltenIncidents Ladefehler';
export const GET_MEINE_ERSTELLTEN_INCIDENTS_NICHT_AUSGEFUEHRT = '[IncidentsModul] GetMeineErstelltenIncidents nicht ausgeführt (evtl. Offline)';


export class GetMeineErstelltenIncidentsAction implements Action {
    readonly type = GET_MEINE_ERSTELLTEN_INCIDENTS;
        constructor( public veranstaltung_id:Array<string> , public optPayload: any = null) {}
    }
export class GetMeineErstelltenIncidentsAusfuehrenAction implements Action {
    readonly type = GET_MEINE_ERSTELLTEN_INCIDENTS_AUSFUEHREN;
        constructor( public veranstaltung_id:Array<string> , public optPayload: any = null) {}
    }
export class GetMeineErstelltenIncidentsErfolgreichAction implements Action {
    readonly type = GET_MEINE_ERSTELLTEN_INCIDENTS_ERFOLGREICH;
        constructor(public payload: api.IncidentsListResponse,  public veranstaltung_id:Array<string> , public optPayload: any = null) {}
    }
export class GetMeineErstelltenIncidentsFehlerAction implements Action {
    readonly type = GET_MEINE_ERSTELLTEN_INCIDENTS_FEHLER;
        constructor(public payload: any,  public veranstaltung_id:Array<string> , public optPayload: any = null) {}
    }
export class GetMeineErstelltenIncidentsNichtAusgefuehrtAction implements Action {
    readonly type = GET_MEINE_ERSTELLTEN_INCIDENTS_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type IncidentsQueryMeineErstelltenIncidentsActions =
    GetMeineErstelltenIncidentsAction
    | GetMeineErstelltenIncidentsAusfuehrenAction
    | GetMeineErstelltenIncidentsErfolgreichAction
    | GetMeineErstelltenIncidentsFehlerAction
    | GetMeineErstelltenIncidentsNichtAusgefuehrtAction
    ;
